import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=3881a730&scoped=true"
import script from "./ContentCard.vue?vue&type=script&lang=js"
export * from "./ContentCard.vue?vue&type=script&lang=js"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=3881a730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3881a730",
  null
  
)

export default component.exports